import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/features/overview/overview-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Vue d'ensemble d'un projet — `docs/porting/vague-1/projet-vue-ensemble.md`, acte 2 de la démo.
 * C'est l'URL canonique du projet : la liste des projets, le formulaire de création et l'entrée
 * « Vue d'ensemble » de la navigation y mènent. Le projet est nommé par le sélecteur de projet.
 */
export const Route = createFileRoute('/$tenant/projects/$projectId/')({ component: ProjectOverviewRoute });

function ProjectOverviewRoute() {
  const { tenant, projectId } = Route.useParams();

  return (
    <ConsoleShell tenantId={tenant} projectId={projectId} activeItem="overview" crumbs={[]}>
      <OverviewPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
